import {
  IForm_File,
} from '../types/schema/form'

export const isImageExtension = (filename: string): boolean => {
  if(!filename) return false
  if(filename.match(/\.(jpg)|(png)|(jpeg)|(gif)$/i)) return true
  return false
}

export const isImage = (data: IForm_File): boolean => {
  let type: string = ''
  let filename: string = ''
  if(data.meta) {
    type = data.meta.type
    filename = data.meta.filename
  }
  else {
    type = (data as any).type
    filename = (data as any).filename
  }
  if((type || '').indexOf('image') == 0) return true
  return isImageExtension(filename)
}

export const isVideoExtension = (filename: string): boolean => {
  if(!filename) return false
  if(filename.match(/\.(mp4)|(mov)|(wmv)|(avi)|(flv)|(mkv)|(webm)$/i)) return true
  return false
}

export const isVideo = (data: IForm_File): boolean => {
  let filename: string = ''
  if(data.meta) {
    filename = data.meta.filename
  }
  else {
    filename = (data as any).filename
  }
  return isVideoExtension(filename)
}

export const getFileExtension = (filename: string): string => {
  const parts = filename.split('.')
  return parts[parts.length - 1].toLowerCase()
}

export const isFolder = (filename: string): boolean => {
  return filename.match(/\/$/) ? true : false;
}

export const getFilename = (filename: string): string => {
  const nameParts = filename.split('/')
  return isFolder(filename) ?
      nameParts[nameParts.length - 2] :
      nameParts[nameParts.length - 1]
}